import { FC } from 'react'
import { default as MuiDrawer, DrawerProps as MuiDrawerProps } from '@mui/material/Drawer'

export type DrawerProps = Pick<
  MuiDrawerProps,
  'anchor' | 'children' | 'hideBackdrop' | 'onClose' | 'open' | 'variant' | 'PaperProps'
>
/**
 *  Navigation drawers provide access to destinations in your app. Side sheets are surfaces containing supplementary content that are anchored to the left or right edge of the screen.
 */
export const Drawer: FC<DrawerProps> = (props: DrawerProps) => (
  <MuiDrawer {...props} elevation={3} />
)
